import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has been scrolled past.
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-brand/25 bg-ink-950/95 px-3 pb-[calc(0.6rem+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-111" data-mp="gokox0i51iig">
      <a href={CHECKOUT_URL} aria-hidden={!visible} tabIndex={visible ? 0 : -1} className="mx-auto flex w-full max-w-md animate-shake items-center justify-center gap-2 rounded-xl bg-brand px-4 py-3.5 font-display text-sm uppercase tracking-wide text-ink-950 shadow-[0_8px_24px_-10px_rgba(255,194,14,0.9)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand sm:text-base" data-id="element-112" data-mp="14dn481pauz9s">
        <ZapIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-113" data-mp="1rcwop3n2fyyr" />
        Jetzt Zugang für 19 € sichern
      </a>
    </div>;
}